/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { Graphql } from '@common/graphql';
import { GET_USER_PROFILE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { featuresSection } from '../../config/featuresSection.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';
import { getUserId } from '../provider';

export interface IGetProfileMethods extends IPluginMethodMap {
  getProfile(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetProfileService implements IAgentPlugin {
  readonly methods: IGetProfileMethods;

  constructor() {
    this.methods = {
      getProfile: this.getProfile.bind(this),
    };
  }

  async getProfile(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    const { userId } = getUserId();

    try {
      if (client) {
        console.log(client);
        const res = await client
          .query(GET_USER_PROFILE, {
            input: { vuid: userId },
          })
          .toPromise();
        console.log('profileress->', res, token);
        if (res?.data?.getUser) {
          let _res = res?.data?.getUser;
          return {
            ..._res,
            title: `${toHeaderCase(_res?.lastName ?? '')}, ${toHeaderCase(
              _res?.firstName ?? ''
            )}`,
            subtitle: _res?.vuid
              ? `Account ID: ${_res?.vuid}`
              : _res?.occupation,
            heroImage: {
              image: _res?.image ?? 'https://i.ibb.co/k6hxpL1p/image.png',
              // `https://ui-avatars.com/api/?name=${_res.lastName}+${_res?.firstName}&background=0D8ABC&color=fff`,
            },
            listItems: this.getListItems(_res),
            initialData: {
              lastName: _res?.lastName,
              firstName: _res?.firstName,
              image: _res?.image,
              telephone: _res?.primaryContactNo,
              address: _res?.address?.addressLine1,
              city: _res?.address?.city,
              country: _res?.address?.country,
              occupation: _res?.occupation,
              status: _res?.accountStatus,
            },
            statusComp: this.statusComp(_res?.accountStatus),
            buttons:
              _res?.role?.[0]?.name === 'owner'
                ? []
                : this.getButtons(
                    featuresSection?.buttons,
                    _res?.role?.[0]?.name,
                    _res?.accountStatus,
                    _res?.role?.length > 1
                  ),
          };
        }

        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      throw err;
    }
  }
  private getButtons(
    btns: any[],
    role: string,
    status: string,
    isMultiRole: boolean
  ) {
    const admin = ['revoke', 're-invite', 'suspend', 'activate'];
    const user = ['remove', 're-invite'];
    const format: any = {
      TEMPORARILY_UNAVAILABLE: ['remove', 'revoke', 'suspend'],
      INVITED: ['re-invite'],
      ACTIVE: ['remove', 'revoke', 'suspend'],
      SUSPENDED: ['remove', 'activate', 'revoke'],
    };
    const isAdmin = role === 'admin';
    const bucket = isAdmin
      ? isMultiRole
        ? admin
        : admin.filter((item) => item !== 'revoke')
      : user;
    if (format?.[status]) {
      return format?.[status]
        ?.filter((item: any) => bucket.includes(item))
        ?.map((item: any) => {
          return btns?.filter((_item) => _item?.key === item)?.[0];
        });
    }
  }

  private statusComp = (status: any) => {
    console.log('status->', status);
    if (status === 'ACTIVE') {
      return {
        title: `Active`,
        statusType: 'success',
      };
    }
    if (status === 'TEMPORARILY_UNAVAILABLE') {
      return {
        title: `Inactive`,
        statusType: 'warning',
      };
    }
    if (status === 'SUSPENDED') {
      return {
        title: `Suspended`,
        statusType: 'danger',
      };
    }
    if (status === 'DEACTIVATED') {
      return {
        title: `Deactivated`,
        statusType: 'danger',
      };
    }
    if (status === 'INVITED') {
      return {
        title: `Invited`,
        statusType: 'warning',
      };
    }
  };

  private getListItems(res: any) {
    let _temp: any[] = [];
    featuresSection?.listItems?.map((item) => {
      if (item?.title === 'Last Name') {
        _temp.push({
          ...item,
          subTitle: res?.lastName ? `${toHeaderCase(res?.lastName)}` : '-',
        });
      }
      if (item?.title === 'First Name') {
        _temp.push({
          ...item,
          subTitle: res?.firstName ? `${toHeaderCase(res?.firstName)}` : '-',
        });
      }
      if (item?.title === 'Middle Name' && res?.middleName) {
        _temp.push({
          ...item,
          subTitle: res?.middleName ? `${toHeaderCase(res?.middleName)}` : '-',
        });
      }

      if (item?.title === 'Role') {
        _temp.push({
          ...item,
          subTitle: res?.role?.[0]?.name
            ? `${toHeaderCase(res?.role?.[0]?.name)}`
            : '-',
        });
      }

      if (item?.title === 'TRN') {
        _temp.push({
          ...item,
          subTitle: res?.trn ? `${toHeaderCase(res?.trn)}` : '-',
        });
      }
      if (item?.title === 'Nationality' && res?.nationality) {
        _temp.push({
          ...item,
          subTitle: res?.nationality
            ? `${toHeaderCase(res?.nationality)}`
            : '-',
        });
      }
      if (item?.title === 'Telephone') {
        console.log('phnooo', toHeaderCase(res?.primaryContactNo));
        _temp.push({
          ...item,
          subTitle: res?.primaryContactNo ? res?.primaryContactNo : '-',
        });
      }
      if (item?.title === 'Email') {
        _temp.push({
          ...item,
          subTitle: res?.email ? res?.email : '-',
        });
      }
    });
    return _temp;
  }
}
